import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

// Todas as telas do Kanban são LAZY (carregadas sob demanda por rota) — assim as
// ~20 telas grandes (board, flows, email/GrapesJS, projetos, chat) NÃO entram no
// bundle inicial do dashboard. Quem só usa a caixa de entrada não baixa nada disso.
const perms = ['administrator', 'agent', 'custom_role'];

// As telas de RELATÓRIO nossas seguem o mesmo portão dos relatórios nativos: se
// o recurso "Reports" está desligado na conta, NENHUM relatório aparece. Sem
// isto, desligar Reports escondia os relatórios do Chatwoot e deixava só os
// nossos na barra lateral — o usuário via "Relatórios > Relatórios CRM" sozinho
// e achava que a permissão da função tinha falhado.
const permsRelatorio = {
  permissions: perms,
  featureFlag: FEATURE_FLAGS.REPORTS,
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban_home',
    meta: { permissions: perms },
    component: () => import('./KanbanBoard.vue'),
  },
  {
    // Dashboard App aberto em tela cheia (opção "Exibir no menu principal").
    path: frontendURL('accounts/:accountId/apps/:appId'),
    name: 'dashboard_app_show',
    meta: { permissions: perms },
    component: () => import('./DashboardAppEmbed.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/kanban/funnels'),
    name: 'kanban_funnels',
    meta: { permissions: perms },
    component: () => import('./KanbanFunnels.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/kanban/cards/:cardId'),
    name: 'kanban_card_detail',
    meta: { permissions: perms },
    component: () => import('./KanbanCardDetail.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/flows'),
    name: 'kanban_flows',
    meta: { permissions: perms },
    component: () => import('./KanbanFlows.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/crm-reports'),
    name: 'kanban_reports',
    meta: permsRelatorio,
    component: () => import('./KanbanReports.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/calls-report'),
    name: 'kanban_calls',
    meta: permsRelatorio,
    component: () => import('./KanbanCalls.vue'),
  },
  {
    // legado: o painel de Ligações nativo do Chatwoot assumiu o /calls. Mantido
    // em /calls-legacy só para links antigos; fora do menu.
    path: frontendURL('accounts/:accountId/calls-legacy'),
    name: 'kanban_calls_center',
    meta: permsRelatorio,
    component: () => import('./KanbanCallsCenter.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/flows/:flowId/history/:executionId'),
    name: 'kanban_flow_execution_detail',
    meta: { permissions: perms },
    component: () => import('./KanbanFlowExecutionDetail.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/flows/:flowId/history'),
    name: 'kanban_flow_history',
    meta: { permissions: perms },
    component: () => import('./KanbanFlowHistory.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/flows/:flowId'),
    name: 'kanban_flow_builder',
    meta: { permissions: perms },
    component: () => import('./KanbanFlowBuilder.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/projects'),
    name: 'kanban_projects',
    meta: { permissions: perms },
    component: () => import('./KanbanProjects.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/projects/:projectId'),
    name: 'kanban_project_detail',
    meta: { permissions: perms },
    component: () => import('./KanbanProjectDetail.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/appointments'),
    name: 'kanban_appointments',
    meta: { permissions: perms },
    component: () => import('./KanbanAppointments.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/disparador'),
    name: 'kanban_campaigns',
    meta: { permissions: perms },
    component: () => import('./KanbanCampaigns.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/disparador/new'),
    name: 'kanban_campaign_wizard',
    meta: { permissions: perms },
    component: () => import('./KanbanCampaignWizard.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/disparador/:campaignId'),
    name: 'kanban_campaign_detail',
    meta: { permissions: perms },
    component: () => import('./KanbanCampaignDetail.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/email'),
    name: 'kanban_email',
    meta: { permissions: perms },
    component: () => import('./KanbanEmail.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/email/new'),
    name: 'kanban_email_wizard',
    meta: { permissions: perms },
    component: () => import('./KanbanEmailWizard.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/email/templates/new'),
    name: 'kanban_email_template_new',
    meta: { permissions: perms },
    component: () => import('./KanbanEmailTemplateEditor.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/email/templates/:templateId'),
    name: 'kanban_email_template',
    meta: { permissions: perms },
    component: () => import('./KanbanEmailTemplateEditor.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/email/:campaignId'),
    name: 'kanban_email_report',
    meta: { permissions: perms },
    component: () => import('./KanbanEmailReport.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/internal-chats'),
    name: 'kanban_internal_chats',
    meta: { permissions: perms },
    component: () => import('./KanbanChats.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/connections'),
    name: 'kanban_connections',
    // gestão de conexões é de administrador (o backend recusa o resto de todo
    // jeito; aqui é só para não abrir uma tela que vai falhar)
    meta: { permissions: ['administrator'] },
    component: () => import('./KanbanConnections.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/synapse'),
    name: 'synapse',
    // função personalizada só entra com o módulo Synapse concedido (sem isto a
    // tela abriria pela URL mesmo com o item escondido do menu)
    meta: { permissions: ['administrator', 'agent', 'synapse_module'] },
    component: () => import('../synapse/SynapseView.vue'),
  },
  {
    // ambientes do Synapse (o que cada função vê/faz + prompt do Cérebro):
    // configurar quem pode o quê é decisão de administrador
    path: frontendURL('accounts/:accountId/synapse/settings'),
    name: 'synapse_settings',
    meta: { permissions: ['administrator'] },
    component: () => import('../synapse/SynapseSettings.vue'),
  },
];
